import React from "react";
import Page from "./page";
import firebase from 'firebase/app';
import 'firebase/firestore';
import CarTypesService, { CarTypesInterface } from "../services/car_types_service";
import Image from '../assets/exit.png';
import Swal from "sweetalert2";
import swal from "sweetalert";


class CarTypes extends React.Component {
    state: {
        isLoading: boolean,
        types: firebase.firestore.QueryDocumentSnapshot[],
    } = {
            isLoading: true,
            types: [],
        }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        return await new CarTypesService().getTypes().then(response => {
            this.setState({
                isLoading: false,
                types: response.docs,
            })
        });
    }

    async handleDelete(id: string) {
        const response = await swal({
            title: "Estas Segur@",
            text: "Esta accion no es reversible",
            buttons: [
                "Si, Eliminar",
                "No, Cerrar"
            ]
        })

        if(response == null){
            Swal.showLoading();
            await new CarTypesService().deleteType(id);
            await this.getData();
            Swal.close();
        }
    }

    renderContent(): JSX.Element {
        if (this.state.isLoading) {
            return (
                <progress className="progress is-large is-info" max="100" style={{
                    width: "60%",
                    margin: "auto"
                }} />
            );
        } else if (this.state.types.length == 0) {
            return (
                <div style={{ display: "block", textAlign: "center", marginTop: "55", }}>
                    <h3>No se encontraron Resultados</h3>
                    <img src={Image} alt="asdac23dew" style={{ height: "50vh" }} />
                </div>
            );
        } else {
            return (
                <div style={{ marginTop: 90 }} className="container-results-types">
                    {
                        this.state.types.map(element => {
                            const doc = element.data() as CarTypesInterface;

                            return (
                                <div className="card card-type" >
                                    <img src={doc.image as any} alt="asdasd1223" style={{ height: "8vh" }} className="image-type" />
                                    <br />
                                    <p>
                                        Nombre:
                                        <strong>
                                            {doc.name}
                                        </strong>
                                    </p>
                                    <p>Valor: <strong>{doc.value} MXN</strong></p>
                                    {element.id != "hYzf0GOAYGJ4kOdxu2qZ" && <button className="button is-danger" onClick={() => this.handleDelete(element.id)}>
                                        Eliminar
                                    </button>}
                                </div>
                            );
                        })
                    }
                </div>
            );
        }
    }

    async handleTap() {
        const name: string = (await Swal.fire({
            title: "Agregar Servicio",
            text: "Ingresa el nombre del nuevo tipo de servicio",
            input: "text",
        })).value;

        const amount = (await Swal.fire({
            title: "Valor",
            text: "Este valor será agregado al total del servicio: Ej 250MXN + 20MXN",
            input: "number",
        })).value;

        const image = (await Swal.fire<File>({
            title: "Imagen de Muestra",
            text: "Esta es la imagen de muestra que verá el usuario",
            input: "file",
        })).value;

        if (!!name && !!amount && !!image) {
            Swal.showLoading();

            await new CarTypesService().createType({
                name,
                value: parseFloat(amount),
                createdAt: new Date().toISOString(),
                image,
            });
            await this.getData();
            Swal.hideLoading();
            Swal.fire("Servicio agregado correctamente");
        } else {
            Swal.fire("Todos los campos son obligatorios")
        }

    }

    render() {
        return (
            <Page>
                <div style={{ padding: 15 }}>
                    <h1 className="title">Tipos de Servicios</h1>
                    <div className="create-type-container">
                        <button className="button is-success" onClick={() => this.handleTap()}>
                            Agregar un Servicio
                        </button>
                    </div>
                    {
                        this.renderContent()
                    }
                </div>
            </Page>
        );
    }
}

export default CarTypes;